export const keyCodeTypes = {
  Enter: 'Enter',
  NumpadEnter: 'NumpadEnter',
  ArrowUp: 'ArrowUp',
  ArrowDown: 'ArrowDown',
  ArrowLeft: 'ArrowLeft',
  ArrowRight: 'ArrowRight',
  Esc: 'Escape',
  Backspace: 'Backspace',
  Space: 'Space',
  KeyP: 'KeyP'
};
